import SelectKngCatalogV2 from './src/main';

/* istanbul ignore next */
SelectKngCatalogV2.install = function(Vue) {
  Vue.component(SelectKngCatalogV2.name, SelectKngCatalogV2);
};

export default SelectKngCatalogV2;
